/**
 * Audio Manager - Single Playback Control
 * Ensures only one audio element plays at a time on the page
 * Automatically stops and resets other audio when a new one starts
 */

(function() {
    'use strict';
    
    let audioElements = [];
    let currentlyPlaying = null;
    
    /**
     * Initialize the audio manager
     */
    function initAudioManager() {
        // Find all audio elements on the page
        audioElements = Array.from(document.querySelectorAll('audio'));
        
        if (audioElements.length === 0) {
            console.log('AudioManager: No audio elements found on page');
            return;
        }
        
        console.log(`AudioManager: Found ${audioElements.length} audio elements`);
        
        // Add event listeners to each audio element
        audioElements.forEach(function(audio, index) {
            // Add play event listener
            audio.addEventListener('play', function() {
                handleAudioPlay(audio);
            });
            
            // Add ended event listener to clear currentlyPlaying
            audio.addEventListener('ended', function() {
                if (currentlyPlaying === audio) {
                    currentlyPlaying = null;
                }
            });
            
            // Add pause event listener to clear currentlyPlaying if manually paused
            audio.addEventListener('pause', function() {
                if (currentlyPlaying === audio) {
                    currentlyPlaying = null;
                }
            });
            
            // Optional: Add a data attribute for easier identification
            if (!audio.dataset.audioId) {
                audio.dataset.audioId = 'audio-' + index;
            }
        });
    }
    
    /**
     * Handle when an audio element starts playing
     * @param {HTMLAudioElement} playingAudio - The audio element that started playing
     */
    function handleAudioPlay(playingAudio) {
        console.log('AudioManager: Audio started playing:', playingAudio.dataset.audioId || playingAudio.src);
        
        // Stop and reset all other audio elements
        audioElements.forEach(function(audio) {
            if (audio !== playingAudio) {
                if (!audio.paused) {
                    audio.pause();
                    console.log('AudioManager: Stopped audio:', audio.dataset.audioId || audio.src);
                }
                // Reset to beginning
                audio.currentTime = 0;
            }
        });
        
        // Update currently playing reference
        currentlyPlaying = playingAudio;
    }
    
    /**
     * Public method to stop all audio (can be called externally if needed)
     */
    function stopAllAudio() {
        audioElements.forEach(function(audio) {
            if (!audio.paused) {
                audio.pause();
            }
            audio.currentTime = 0;
        });
        currentlyPlaying = null;
        console.log('AudioManager: All audio stopped and reset');
    }
    
    /**
     * Public method to get currently playing audio
     */
    function getCurrentlyPlaying() {
        return currentlyPlaying;
    }
    
    /**
     * Handle dynamic content - reinitialize if new audio elements are added
     */
    function reinitialize() {
        console.log('AudioManager: Reinitializing...');
        initAudioManager();
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAudioManager);
    } else {
        // DOM is already loaded
        initAudioManager();
    }
    
    // Expose public methods to global scope (optional)
    window.AudioManager = {
        stopAll: stopAllAudio,
        getCurrentlyPlaying: getCurrentlyPlaying,
        reinitialize: reinitialize
    };
    
    // Handle potential dynamic content loading (useful for Shopify themes)
    // Listen for common events that might indicate new content has been loaded
    const dynamicContentEvents = ['shopify:section:load', 'page:loaded', 'turbo:load'];
    
    dynamicContentEvents.forEach(function(eventName) {
        document.addEventListener(eventName, function() {
            // Small delay to ensure content is fully rendered
            setTimeout(reinitialize, 100);
        });
    });
    
})();